export const experienceData = [
    {
        id: 1,
        company: 'at Dinz English · Self-employed',
        jobtitle: 'Private English Tutor',
        startYear: '2020',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'at KB/TK Baitul Mukmin Surabaya',
        jobtitle: 'English Teacher',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        company: 'at English Land Surabaya',
        jobtitle: 'High School English Teacher',
        startYear: '2017',
        endYear: '2017'
    },
    

    {
        id: 4,
        company: 'at Dynamic English Course Surabaya',
        jobtitle: 'English Tutor',
        startYear: '2015',
        endYear: '2020'
    },
   
]